import degreesConfig from "@2u-landing-pages/constants/configs/degrees.json";

const programConfigs = degreesConfig.programs.ec;

export const ec = {
  slug: "ec",
  name: "Emerson College",
  colors: {
    primary1: "#fff",
    text: "#000",
  },
  fonts: {
    base: "Avenir Next Pro, sans-serif",
    url: "https://whitelabel.2u.com/cdn/v1/14bc3325-09a2-466a-b133-180d397169dc/marketing/whitelabel.fonts.min.css?ver=1.0",
  },
  programConfigs,
};

